import {ActiveDataFilter} from "../common/DataFilter";
import {DateRange} from "../common/DateRange";
import {FilterTypes} from "../../helpers/FilterTypes";


/**
 * added to each request to show only non deleted items on the calendar view
 * */
export function calendarDeleteFilter(): ActiveDataFilter<boolean> {
    return {
        identifier: "filter__isDeleted",
        type: FilterTypes.BOOL,
        isInverted: false,
        selectedValue: false,
        displayName: ""
    };
}

export function calendarTimePeriodFilter( dateRange: DateRange ): ActiveDataFilter< Date >[] {
    return [
        {
            identifier: 'filter__startAt',
            type: FilterTypes.START_DATE,
            isInverted: false,
            selectedValue: dateRange.start,
            displayName: ""
        },
        {
            identifier: 'filter__finishAt',
            type: FilterTypes.END_DATE,
            isInverted: false,
            selectedValue: dateRange.endInclusive,
            displayName: ""
        }
    ];
}